import { initReactI18next } from "react-i18next";
import { resources } from "@/utils/constant";

import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "fa",
    resources,
    fallbackLng: "fa",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
